/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
/* Styles */
/* Services */

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const PsQuote = ({ sectionContent, lang, region }) => {
  return (
    <Box
      w="100%"
      bgImage={{
        base: `${config.imgPath}/d/46272/1724183488-group-1171277672.png`,
        md: `${config.imgPath}/d/46272/1724183495-group-1171277933.png`,
      }}
      backgroundRepeat="no-repeat"
      backgroundSize={{
        base: '100% 100%',
        sm: '100% 100%',
        md: 'cover',
        lg: 'cover',
      }}
      bgPos={{ base: 'top', lg: 'center' }}
      minH={{ md: '770px', base: '490px' }}
      objectFit="cover"
    >
      <Flex
        mt={{ sm: '11.0625rem', base: '4.1rem' }}
        paddingX={{ lg: '.5rem', xl: '1.4rem' }}
        maxW={'974px'}
        mx={{ base: '.5rem', sm: '1rem', md: '2rem', lg: 'auto' }}
        fontWeight={350}
        color={'#010509'}
        textAlign={'center'}
        letterSpacing={'0.32px'}
        fontSize={{ '2xl': '1.75rem', md: '20px', base: '1.125rem' }}
        lineHeight={{ base: '1.8rem', md: '34px', '2xl': '2.8rem' }}
        fontFamily={'var(--FedraSansStd-book)'}
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        {sectionContent?.quote}
      </Flex>
      <Box
        display={{ base: 'flex' }}
        width={{ base: '154px', md: '200px', lg: '370px', '2xl': '470px' }}
        height={{ base: '43px', lg: '107px', '2xl': '135px' }}
        justifyContent={'center'}
        mt={{ base: '4rem', md: '5rem', '2xl': '8rem' }}
        mx="auto"
        maxW="500px"
      >
        <LazyLoadImageComponent
          src={`${config.imgPath}/d/46272/1721308187-workshopkolam.png`}
          alt="Workshop Kolam"
          // width={400}
          // height={250}
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default PsQuote;
